import { extractBackendCode } from '@lib/api/extractBackendCode';

/**
 * Whether a document write was refused because the document is the source of a
 * data-analysis import (`400 DOCUMENT_ANALYSIS_SOURCE`, `auditDocument.controller.js`).
 * Matched on the code alone: every API that can refuse this sends it (#760).
 */
export function isDocumentAnalysisSourceRefusal(error: unknown): boolean {
  return extractBackendCode(error) === 'DOCUMENT_ANALYSIS_SOURCE';
}
